import type { RtoTermDefinition } from "@/lib/rto/rtoTermSettings";

export function normalizeStateCode(code: string): string {
  return code.trim().toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);
}

export function mergeStatePayoffMap(term: RtoTermDefinition, states: string[]): Record<string, number> {
  const existing = term.early_purchase_percent_by_state ?? {};
  const next: Record<string, number> = {};
  for (const st of states) {
    const value = Number(existing[st]);
    next[st] = Number.isFinite(value) && value > 0 ? value : term.early_purchase_percent;
  }
  return next;
}

export function deriveRtoStates(terms: RtoTermDefinition[]): string[] {
  const out = new Set<string>();
  for (const term of terms) {
    const map = term.early_purchase_percent_by_state ?? {};
    for (const key of Object.keys(map)) {
      const code = normalizeStateCode(key);
      if (code) out.add(code);
    }
  }
  return Array.from(out).sort();
}
